(function ($) {

    function calcDescription() {
        $('.description').each(function () {
            $(this).addClass('active');
            var height = $(this).outerHeight(true);
            $(this).css('height', height);
            $(this).removeClass('active');
        });
    }

    $(window).on('load', function () {
        calcDescription();

        var heroSwiper = new Swiper('.swiper-container', {
            loop: true,
            autoplay: {
                delay: 5000,
            },

            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    return '<div class="' + className + '">' + (slideText[index]) + '</div>';
                }
            },

            on: {
                activeIndexChange: function () {
                    $('.swiper-pagination').removeClass('animate');
                    var currentSlide = this.slides[this.activeIndex];
                    $(currentSlide).find('svg').addClass('animate');
                    setTimeout(function () {
                        $('.swiper-pagination').addClass('animate');
                    }, 500);
                },
            },

            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        $('.cookie-button').on('click', function () {
            $('.cookiebox').addClass('success');
            setCookie('consent', '1', '1');
        });

        function setCookie(key, value, expiry) {
            var expires = new Date();
            expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
            document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
        }

        $('.about-button').on('click', function (el) {
            el.preventDefault();
            $('html, body').animate({
                scrollTop: $($(this)[0].hash).offset().top
            }, 1000);
        });

        $('.mobile-burger').on('click', function () {
            $(this).toggleClass('active');
            $('.mobile-menu').toggleClass('active');
        });


        $('.button-tab').on('click', function () {
            $(this).siblings().removeClass('active');
            $(this).addClass('active');
            var target = $(this).attr('data-target');
            $(this).closest('.team-content').children().removeClass('active');
            var content = $(this).closest('.team-content').find('.' + target);
            content.addClass('active');
        });

        $('.expand-button').on('click', function () {
            var button = $(this).find('.expand-text');
            var desc = $(this).closest('.member-information').find('.description');

            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                desc.removeClass('active');
                button.text('More');
            } else {
                $(this).addClass('active');
                desc.addClass('active');
                button.text('Less');
            }
        });

    });

    $(window).on('scroll', function () {

    });

    $(window).on('resize', function () {

    });

})(jQuery);